// src/Components/PublicLayout.js

import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { LandingContext } from '../../Components/Profile/LandingContext';
import config from '../../Common/Configurations/APIConfig';
import apiService from '../../Common/Configurations/APIService';
import B2CFooter from '../../Common/Layout/B2CFooter';
import DefaultData from '../../CompanyData/DefaultData';
import PublicHeader from '../../Common/Layout/PublicHeader';

const PublicLayout = () => {
    const [landingData, setLandingData] = useState(null);

    useEffect(() => {
        const getLandingData = async () => {
            const companyId = DefaultData.DEFAULTCOMPANYID; 
            if (!companyId) return;
            try {
                const res = await apiService.getAll(`${config.GETLANDINGBYCOMPANY}/${companyId}`);
                if (res.data && res.data.length > 0) {
                    setLandingData(res.data[0]);
                }
            } catch (error) {
                console.error("Failed to fetch landing page data for public layout", error);
            }
        };
        getLandingData();
    }, []);

    return (
        // This Provider makes 'landingData' available to PublicHeader, Outlet, and B2CFooter
        <LandingContext.Provider value={landingData}>
            <div className="b2c-wrapper">
                {/* No need to pass props anymore, it will get data from context */}
                <PublicHeader />
                <main className="main-content">
                    <Outlet />
                </main>
                <B2CFooter value={landingData} />
            </div>
        </LandingContext.Provider>
    );
};

export default PublicLayout;